// @ref https://day.js.org/docs/en/timezone/timezone
import { DEFAULT_FORMAT_DATE } from "constants/datetime";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

// TODO: Update "timezone" value by getting from API
dayjs.tz.setDefault("Asia/Ho_Chi_Minh");

export const dayjsTZ = (
  date?: string | number | Date | dayjs.Dayjs | null | undefined
) => {
  return dayjs(date).tz();
};

export default dayjs;

export const formatDate = (dateTime?: any, format?: string) => {
  if (dateTime) {
    return dayjs(dateTime).format(format ?? DEFAULT_FORMAT_DATE);
  }
  return "";
};
